<form class="cancel-amortization-plan-form astral-stack-m" [formGroup]="form" (ngSubmit)="onSubmit()">
  <h4>{{ 'AMORTIZATION_PLAN.CANCEL.TITLE' | translate }}</h4>
  <app-information-block [text]="'AMORTIZATION_PLAN.CANCEL.INFO' | translate"></app-information-block>

  <section class="astral-section-surface astral-section-surface--compact astral-stack-m">
    @if (canSendInvoicesToDebtCollection) {
      <astral-checkbox
        [control]="form.controls['sendInvoicesToDebtCollection']"
      ></astral-checkbox>
    }

    @if (!canSendInvoicesToDebtCollection) {
      <app-information-block
        [text]="'AMORTIZATION_PLAN.CANCEL.DEBT_COLLECTION_NOT_CONFIGURED' | translate"
      ></app-information-block>
    }

    <astral-textarea [control]="form.controls['reason']" [rows]="4"></astral-textarea>
  </section>

  <div class="astral-form-actions">
    <astral-button
      variant="primary"
      [disabled]="working"
      type="submit"
      labelKey="AMORTIZATION_PLAN.CANCEL.ACTION"
    ></astral-button>
    <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
  </div>
</form>
